window.addEventListener('DOMContentLoaded', function () {
  let options = {
    onOpen: function (currentElement) {
      // Scroll to product page accordion on mobile devices
      let accordionTop = currentElement.getBoundingClientRect().top
      let headerHeight = document.querySelector('header div').getBoundingClientRect().height
      window.scrollTo(0, accordionTop + window.scrollY - headerHeight)
    }
  };

  if ($('.product-accordions-wrapper [data-auto-open]').length) {
    options.openOnInit = $('.product-accordions-wrapper [data-auto-open]')
      .get()
      .map(function (elem, idx) {
        return idx;
      });
  }
  jQuery(function ($) {
    new Accordion('.product-accordions-wrapper', options);

    // Setup Swiper carousels

    window.theme.thumbsCarousel = new Swiper('.thumbs-carousel-wrapper', {
      slidesPerView: 4.1,
      spaceBetween: 8,
      slidesPerGroup: 4,
      direction: 'horizontal',
      breakpoints: {
        1280: {
          slidesPerView: 5,
          spaceBetween: 8,
          slidesPerGroup: 4,
          direction: 'vertical',
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 8,
          slidesPerGroup: 4,
          direction: 'horizontal',
        },
      },
    });

    window.theme.mainCarousel = new Swiper('.main-carousel-wrapper', {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.main-carousel-navigation .next',
        prevEl: '.main-carousel-navigation .prev',
      },
      thumbs: {
        swiper: window.theme.thumbsCarousel,
      },
      breakpoints: {
        1024: {
          spaceBetween: 16,
        },
      },
    });

    $('.book-camp-cta').on('click', function (e) {
      e.preventDefault();

      window.startCampBooking();
    });

    window.addEventListener('resize', function () {
      if (this.window.innerWidth >= 768) {
        let bookingRoot = document.querySelector('#camp-booking-root');

        if (!bookingRoot) return;

        bookingRoot.scrollTo({ top: 0 });
      }
    });
  });
});
